import type { Routes } from '@angular/router';
import { guestGuard } from '../../core/auth/auth.guard.js';

export const authRoutes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./login/login.component.js').then((m) => m.LoginComponent),
  },
];
